import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { horizontalSigningQueryKeys } from "../queries/horizontalSigning/queryKeys"

import { useHorizontalSigningMutation } from "./useHorizontalSigningMutation"

export function useHorizontalSignDelete(
    signId,
    config = {},
) {
    const url = `horizontal_signs/${signId}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    return useHorizontalSigningMutation(
        url,
        axiosInstance.delete,
        {},
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.project() })
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.layer() })
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.stats_categories() })
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.stats_conditions() })
                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)

                config.onSuccess?.(data)
            },
        },
    )
}